import React, { useState, useEffect, useCallback } from 'react';
import ProductsPage from '../../components/ProductsPage/ProductsPage';
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faUser } from '@fortawesome/free-solid-svg-icons';
import './PageProductosCatalogo.css';
import Cart from '../../components/Cart/Cart';
import Select from 'react-select';
import baseURL from '../../components/url';
import Joyride from 'react-joyride';
import CuponesModal from '../../components/CuponesModal/CuponesModal';
import SwipeHintOverlay from '../../components/SwipeHintOverlay/SwipeHintOverlay';
import ProductsPageCatalogo from '../../components/ProductsPageCatalogo/ProductsPageCatalogo';
import CartCatalogo from '../../components/CartCatalogo/CartCatalogo';
import Modal from 'react-modal';
import Profile from '../../components/Profile/Profile';
import config from '@config';

export default function PageProductosCatalogo() {
    const [cuponAplicado, setCuponAplicado] = useState(localStorage.getItem('cupon') || '')

    const color1 = getComputedStyle(document.documentElement).getPropertyValue('--color1');
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const idCategoriaURL = params.get('idCategoria');

    // Estado para abrir/cerrar el modal del carrito
      const [cartModalOpen, setCartModalOpen] = useState(false);
    const [perfilModalOpen, setPerfilModalOpen] = useState(false);
    // Cantidad de items que mostramos en el ícono de carrito
    const [items, setItems] = useState(0);

    // Categorías y lógica de filtros
    const [categorias, setCategorias] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('');

    // Tallas
    const [selectedTallas, setSelectedTallas] = useState('');
    const [productos, setProductos] = useState([]);

    //Cupones
    const [cupones, setCupones] = useState([]);

    // Control de veces mostrado (máximo 3)
    const [runTour, setRunTour] = useState(false);
    const [showHint, setShowHint] = useState(false);
    const [openCuponesModal, setOpenCuponesModal] = useState(false);

    const steps = [
        {
            target: '#tour-categorias',
            content: 'Aquí puedes filtrar los productos por categoría.',
            disableBeacon: true,
        },
        {
            target: '#tour-tallas',
            content: 'Aquí puedes filtrar los productos por talla disponible.',
        },
        {
            target: '#tour-detalles',
            content: 'Haz clic aquí para ver más detalles y tallas del producto.',
        },
    ];

    const opcionesTallas = [
        { value: 'Ch', label: 'Ch (28 - 30)' },
        { value: 'M', label: 'M (31 - 32)' },
        { value: 'G', label: 'G (33 - 34)' },
        { value: 'Xg', label: 'Xg (35 - 36)' },
        { value: 'Xxg', label: 'Xxg (37 - 38)' },
    ];

    const handleChangeCategoria = (selected) => {
        setCategoriaSeleccionada(selected);
        if (selected && selected.value) {
            navigate(`/productos?idCategoria=${selected.value}`, { replace: true });
        }
    };

    const handleChangeTallas = (selected) => {
        setSelectedTallas(selected);
    };

    // Estilos personalizados para los <Select/>
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? color1 : 'white',
            color: state.isSelected ? 'white' : 'black',
        }),
        control: (provided) => ({
            ...provided,
            maxHeight: '32px',
            overflowY: 'auto',
            paddingRight: '30px',
            borderRadius: '8px',
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: '8px',
        }),
        clearIndicator: (provided) => ({
            ...provided,
            position: 'absolute',
            right: '20px',
            top: '2px',
            zIndex: 1,
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            position: 'absolute',
            right: '-5px',
            top: '2px',
            zIndex: 1,
        }),
    };

    // Cargar categorías
    useEffect(() => {
        cargarCategorias();
        // eslint-disable-next-line
    }, []);

    const cargarCategorias = () => {
        fetch(`${baseURL}/api/categorias`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                let arrayCategorias = [];
                if (Array.isArray(data.categorias) && data.categorias.length > 0) {
                    arrayCategorias = data.categorias.map(({ idCategoria, categoria }) => ({
                        value: idCategoria,
                        label: categoria
                    }));
                }
                setCategorias(arrayCategorias || []);
                // Si hay idCategoria en la URL, selecciona esa, si no la primera
                if (idCategoriaURL) {
                    const found = arrayCategorias.find(cat => String(cat.value) === String(idCategoriaURL));
                    setCategoriaSeleccionada(found || arrayCategorias[0] || '');
                } else {
                    setCategoriaSeleccionada(arrayCategorias[0] || '');
                }
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    useEffect(() => {
        const tourCount = parseInt(localStorage.getItem('tour_count') || '0', 10);
        if (tourCount < 6) {
            setRunTour(true);
        }
    }, []);

    // Cuando termina el tour, muestra la guía de scroll
    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        if (["finished", "skipped"].includes(status) || type === "tour:end") {
            setRunTour(false);
            setShowHint(true);
            // Incrementa el contador en localStorage
            const tourCount = parseInt(localStorage.getItem('tour_count') || '0', 10);
            localStorage.setItem('tour_count', (tourCount + 1).toString());
        }
    };

    // Cuando se cierra la guía de scroll, muestra el modal de cupones
    const handleCloseHint = () => {
        setShowHint(false);
        setTimeout(() => setOpenCuponesModal(true), 200); // Pequeño delay para UX
    };

    // Ocultar el hint al hacer scroll o swipe vertical o clic/arrastre
    const hideHintOnScrollOrSwipe = useCallback(() => {
        handleCloseHint();
    }, []);

    useEffect(() => {
        if (!showHint) return;
        // Handler para swipe/touch vertical
        let lastY = null;
        const onTouchMove = (e) => {
            if (e.touches && e.touches.length > 0) {
                if (lastY === null) lastY = e.touches[0].clientY;
                const deltaY = Math.abs(e.touches[0].clientY - lastY);
                if (deltaY > 30) {
                    hideHintOnScrollOrSwipe();
                }
            }
        };
        // Handler para mouse: solo desaparece con clic o arrastre
        let mouseDown = false;
        const onMouseDown = () => { mouseDown = true; };
        const onMouseUp = () => { if (mouseDown) { hideHintOnScrollOrSwipe(); mouseDown = false; } };
        const onMouseMove = (e) => {
            if (mouseDown && e.movementY && Math.abs(e.movementY) > 10) {
                hideHintOnScrollOrSwipe();
                mouseDown = false;
            }
        };
        window.addEventListener('touchmove', onTouchMove, { passive: true });
        window.addEventListener('mousedown', onMouseDown, { passive: true });
        window.addEventListener('mouseup', onMouseUp, { passive: true });
        window.addEventListener('mousemove', onMouseMove, { passive: true });
        return () => {
            window.removeEventListener('touchmove', onTouchMove);
            window.removeEventListener('mousedown', onMouseDown);
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('mousemove', onMouseMove);
        };
    }, [showHint, hideHintOnScrollOrSwipe]);

    return (
        <>
            <Joyride
                steps={steps}
                run={runTour}
                continuous
                showSkipButton
                styles={{ options: { zIndex: 10000 } }}
                locale={{
                    back: 'Atrás',
                    close: 'Cerrar',
                    last: 'Finalizar',
                    next: 'Siguiente',
                    skip: 'Saltar',
                }}
                callback={handleJoyrideCallback}
            />
            {showHint && (
                <SwipeHintOverlay text="¡Desliza hacia arriba o abajo para ver más productos!" onClose={handleCloseHint} />
            )}
            <CuponesModal openModal={openCuponesModal} setOpenModal={setOpenCuponesModal} />
            <div className="mobileContainer">
                <div className="pageProductosContainer">
                    {/* Header con botón Back y Cart */}
                    <header className="productosHeader">
                        <button className="backButton" onClick={() => navigate("/")}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>

                        <div className='selectCategorias' id="tour-categorias">
                            <Select
                                options={categorias}
                                value={categoriaSeleccionada}
                                onChange={handleChangeCategoria}
                                styles={customStyles}
                                placeholder="Categorías"
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                maxMenuHeight={300}
                                menuPortalTarget={document.body}
                                // isClearable={true}
                                menuPosition="fixed"
                                menuShouldBlockScroll={true}
                            />
                        </div>
                        <div className='selectTallas' id="tour-tallas">
                            <Select
                                options={opcionesTallas}
                                value={selectedTallas}
                                onChange={handleChangeTallas}
                                styles={customStyles}
                                placeholder="Tallas"
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                maxMenuHeight={300}
                                menuPortalTarget={document.body}
                                isClearable={true}
                                menuPosition="fixed"
                                menuShouldBlockScroll={true}
                            />
                        </div>

                        {/* Botón perfil cliente */}
                        <button className="cartIcon" onClick={() => setPerfilModalOpen(true)} style={{ marginRight: 4 }}>
                            <FontAwesomeIcon icon={faUser} />
                        </button>

                        {/* Botón que abre el modal del carrito */}
                        <button className="cartIcon" onClick={() => setCartModalOpen(true)}>
                            <span className="cartCount">{items}</span>
                            <FontAwesomeIcon icon={faShoppingCart} />
                        </button>
                    </header>

                    {/* Modal perfil cliente en catálogo */}
                    <Modal
                        isOpen={perfilModalOpen}
                        onRequestClose={() => setPerfilModalOpen(false)}
                        className="modalNav"
                        overlayClassName="overlay"
                    >
                        <div className="modalNav-content">
                            <Profile />
                        </div>
                    </Modal>

                    {/* Contenedor de Productos */}
                    <ProductsPageCatalogo
                        setItemsProps={setItems}
                        categoriasFiltroProps={categoriaSeleccionada}
                        tallasFiltroProps={selectedTallas?.value}
                        setProductosProps={setProductos}
                        cuponesProps={cupones}
                        cuponAplicado={cuponAplicado}
                        setCuponAplicado={setCuponAplicado}
                        hasWave={config.Catalog?.hasWave || false}
                    />

                    {/* Modal del carrito en esta página (controlado por cartModalOpen) */}
                    <CartCatalogo
                        isFloating={false}
                        isOpen={cartModalOpen}
                        onClose={() => setCartModalOpen(false)} // <-- cierra el modal
                        itemsProps={items}
                        setItemsProps={setItems}
                        setCuponesProps={setCupones}
                        cuponAplicado={cuponAplicado}
                        setCuponAplicado={setCuponAplicado}
                    />
                </div>
            </div>
        </>
    );
}
